import { render, staticRenderFns } from "./LotDetail.vue?vue&type=template&id=ff3f4056&"
import script from "./LotDetail.vue?vue&type=script&lang=js&"
export * from "./LotDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff3f4056')) {
      api.createRecord('ff3f4056', component.options)
    } else {
      api.reload('ff3f4056', component.options)
    }
    module.hot.accept("./LotDetail.vue?vue&type=template&id=ff3f4056&", function () {
      api.rerender('ff3f4056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/avenants_tsuppl/components/LotDetail.vue"
export default component.exports